/** @format */

import React, { FunctionComponent, ReactElement, useEffect, useState } from 'react';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import PaperedTable from '../../../components/Table/PaperedTable';
import { TableBody, TableCell, TableFooter, TableHead, TableRow } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import UploadMsisdnPoolFile from './UploadMsisdnPoolFile';
import Filter from '../../../interfaces/forms/Filter';
import Order from '../../../interfaces/forms/Order';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { FilterListReducerFieldName } from '../../../modules/filter/FilterListReducers';
import { FilterManager } from '../../../modules/filter/FilterManager';
import { FilterReducerFieldName, FilterReducers } from '../../../modules/filter/FilterReducers';
import { StorageReducerAction, StorageReducerType } from '../../../modules/storage/StorageReducers';
import { PlatformPoolFile, PlatformPoolFileCollectionInterface } from '../../../interfaces/collections/PlatformPoolFilesCollectionInterface';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import FilterList from '../../../components/Filter/FilterList';
import I18n from '../../../components/Translate/I18n';
import TableHeaderContentCell from '../../../components/Table/TableHeaderContentCell';
import Pager from '../../../components/Adescom/PagerRange';
import { DateHelperTs } from '../../../helpers/DateHelperTs';
import { usePlatformResellerHeaders, usePlatformResellerList } from '../../../modules/lib/hooks/usePlatformResellerHooks';
import EditButton from '../../../components/Buttons/EditButton';
import TemplateButton from '../../../components/Buttons/TemplateButton';
import { HourglassEmpty, PlayArrow, Report } from '@material-ui/icons';
import DeleteButton from '../../../components/Buttons/DeleteButton';
import { PlatformPoolFileChange } from './PlatformPoolFileChange';
import { AlertDialog } from '../../lib/dialog/AlertDialog';
import { roles, UserRoleHelper } from '../../../helpers/UserRoleHelper';
import { ViewReportDialog } from './ViewReportDialog';
import OPL_STYLE from '../../../assets/themes/OPL/OplStyle';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
const _ = require('underscore');

type MsisdnPoolManagerType = {
    classes: any;
    showMainLoader: (show: boolean) => void;
};

const MsisdnPoolManager: FunctionComponent<MsisdnPoolManagerType> = ({ classes, showMainLoader }): ReactElement => {
    const setDefaultFilters = (): Array<Filter> => [{ name: 'poolType[]', value: 'msisdn' }];
    const setDefaultOrders = (): Array<Order> => [{ name: 'createdAt', value: 'desc' }];
    const [filters, setFilters] = useState<Array<Filter>>(setDefaultFilters());
    const [orders, setOrders] = useState<Array<Order>>(setDefaultOrders());
    const [activeRow, setActiveRow] = useState(-1);
    const dispatch = useDispatch();
    const [reload, setReload] = useState(false);
    const [showClearFilterButton, setShowClearFilterButton] = useState(false);
    const { headerFilterElementHasValue, headerFilterElementName } = useSelector((state: { filterReducer: FilterReducers }) => state.filterReducer);
    const { msisdnPoolList } = useSelector((state: { storageReducers: StorageReducerType }) => state.storageReducers);
    const [openEdit, setOpenEdit] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState<string>('');
    const [actionPool, setActionPool] = useState<PlatformPoolFile | null>(null);
    const [typeOfConfirm, setTypeOfConfirm] = useState(-1);
    const [pool, setPool] = useState<PlatformPoolFile | null>(null);
    const [viewReportDialog, setViewReportDialog] = useState(false);
    const [viewReportPool, setViewReportPool] = useState<PlatformPoolFile | null>(null);

    const platformReseller = usePlatformResellerList();
    const platformResellerHeader = usePlatformResellerHeaders(platformReseller);

    const reloadList = (reload: boolean): void => setReload(reload);

    useEffect(() => {
        setReload(true);
    }, [orders]);

    useEffect(() => {
        if (reload) {
            setReload(false);
            showMainLoader(true);
            const itemLoader = new ItemLoaders(dispatch);
            itemLoader.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_pools_files')),
                StorageReducerAction.LOAD_MSISDN_POOL_FILE_LIST,
                filters,
                orders,
                (data: PlatformPoolFileCollectionInterface) => {
                    dispatch({
                        type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
                        showRender: true,
                    });
                    dispatch({
                        type: StorageReducerAction.LOAD_MSISDN_POOL_FILE_LIST,
                        msisdnPoolList: data,
                    } as StorageReducerType);
                    showMainLoader(false);
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        }
    }, [dispatch, filters, orders, reload, showMainLoader]);

    useEffect(() => {
        const filterManage = new FilterManager();
        if (headerFilterElementName) {
            if (headerFilterElementHasValue) {
                filterManage.manageElement(headerFilterElementName, headerFilterElementHasValue);
            } else {
                filterManage.manageElement(headerFilterElementName, false);
            }
            setShowClearFilterButton(filterManage.hasManageElement());
        }
    }, [headerFilterElementName, headerFilterElementHasValue, dispatch]);

    const clearFilter = (): void => {
        setFilters(setDefaultFilters());
        setOrders(setDefaultOrders());
        setShowClearFilterButton(false);
        dispatch({
            type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            clearAll: true,
        });
        dispatch({
            type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
        });
    };

    const paginationCallbackFunction = (uri: string): void => {
        showMainLoader(true);
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.paginationCallWithCallback(
            uri,
            StorageReducerAction.LOAD_MSISDN_POOL_FILE_LIST,
            (data: PlatformPoolFileCollectionInterface): void => {
                dispatch({
                    type: StorageReducerAction.LOAD_MSISDN_POOL_FILE_LIST,
                    msisdnPoolList: data,
                } as StorageReducerType);
                showMainLoader(false);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    const getResellerName = (platformResellerId: number): string => {
        let name = '';
        if (platformReseller) {
            for (let i = 0; i < platformReseller['hydra:member'].length; i++) {
                if (platformReseller['hydra:member'][i].id === platformResellerId) {
                    return platformReseller['hydra:member'][i].mainname;
                }
            }
        }
        return name;
    };

    const updateOrderList = (orders: Array<Order>): void => setOrders(orders);
    const updateFilterList = (filters: Array<Filter>): void => setFilters(filters);
    const firstLoad = (): void => {};

    const editPools = (msisdnPoolFile: PlatformPoolFile): void => {
        setActionPool(msisdnPoolFile);
        setOpenEdit(true);
    };
    const viewReport = (msisdnPoolFile: PlatformPoolFile): void => {
        setViewReportDialog(true);
        setViewReportPool(msisdnPoolFile);
    };

    const confirmCallback = (): void => {
        if (!pool) {
            return;
        }
        switch (typeOfConfirm) {
            case 1:
                pool.runProcess = true;
                break;
            case 2:
                pool.deleted = true;
                break;
            default:
                return;
        }
        const itemLoader = new ItemLoaders(dispatch);
        if (pool['@id']) {
            itemLoader.putWithCallback(
                FormGeneralHelper.getByUri(pool['@id']),
                'put_platform_pool_file_custom',
                pool,
                (data: PlatformPoolFile): void => {
                    showMainLoader(false);
                    reloadList(true);
                    setOpenAlert(false);
                    setAlertTitle('');
                    setAlertMessage('');
                    setTypeOfConfirm(-1);
                },
                { dispatchAfterCallback: false, propagateDataToCallback: true }
            );
        }
    };

    const processPoolFile = (poolFile: PlatformPoolFile): void => {
        setTypeOfConfirm(1);
        setAlertMessage('pools:msisdn.confirm_process_pool');
        setPool(poolFile);
        setOpenAlert(true);
    };

    const deletePoolFile = (poolFile: PlatformPoolFile): void => {
        setTypeOfConfirm(2);
        setAlertMessage('pools:msisdn.confirm_delete_pool');
        setPool(poolFile);
        setOpenAlert(true);
    };

    const tableStickyHeader = { root: classes.tableStickyHeader };
    const tableControlStickyHeader = { root: classes.tableControlStickyHeader };
    const tableCellRoot = { root: classes.tableCellRoot };
    const tableRowRoot = { root: classes.tableRowRoot };
    return (
        <GridContainer spacing={2}>
            <GridItem xs={6}>
                {UserRoleHelper.checkRole(roles.ROLE_UPLOAD_MSISDN_POOLS) && (
                    <UploadMsisdnPoolFile showMainLoader={showMainLoader} reloadList={reloadList} poolType="msisdn" />
                )}
            </GridItem>
            <GridItem xs={12} md={12} lg={12}>
                <PaperedTable
                    beforeTableContent={
                        <GridContainer>
                            <GridItem xs={12} style={{ textAlign: 'left' }}>
                                {showClearFilterButton && (
                                    <CustomTextButtom
                                        callback={clearFilter}
                                        callbackParam={{}}
                                        color={'primary'}
                                        label="general:common.clear"
                                        size="lg"
                                    />
                                )}
                                <CustomTextButtom
                                    callback={(): void => {
                                        showMainLoader(true);
                                        setReload(true);
                                    }}
                                    callbackParam={{}}
                                    color="primary"
                                    label="general:common.search"
                                    size="lg"
                                />
                                <FilterList />
                            </GridItem>
                        </GridContainer>
                    }
                >
                    <TableHead>
                        <TableRow>
                            <TableCell classes={tableControlStickyHeader} padding="none" align="left">
                                <I18n trans="general:common.commands" />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} align="center">
                                <TableHeaderContentCell
                                    textAlign="center"
                                    title="pools:msisdn.range_from"
                                    fieldName="rangeFrom"
                                    showSort={true}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="number"
                                    prependMaxLengthRequirement={9}
                                    filters={filters}
                                    sort={orders}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={firstLoad}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} align="center">
                                <TableHeaderContentCell
                                    textAlign="center"
                                    title="pools:msisdn.range_to"
                                    fieldName="rangeTo"
                                    showSort={true}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="number"
                                    prependMaxLengthRequirement={9}
                                    filters={filters}
                                    sort={orders}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={firstLoad}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} align="center">
                                <TableHeaderContentCell
                                    textAlign="center"
                                    title="pools:msisdn.platform_reseller"
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    fieldName="platformResellerId"
                                    showSort={true}
                                    searchFieldType="select"
                                    selectComponent="headerCheckBoxSimpleList"
                                    elementList={platformResellerHeader}
                                    filters={filters}
                                    sort={orders}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} padding="none" align="center">
                                <TableHeaderContentCell
                                    title="pools:msisdn.created_at"
                                    fieldName="createdAt"
                                    showSort={true}
                                    onlyFilter={false}
                                    defaultDirection="asc"
                                    searchFieldType="date"
                                    dateFormat="RRRR-MM-DD"
                                    dateFromTo={true}
                                    filters={filters}
                                    sort={orders}
                                    breakLine={true}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={firstLoad}
                                    nullable={false}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} padding="none" align="center">
                                <TableHeaderContentCell
                                    title="pools:msisdn.processed_date"
                                    fieldName="processedDate"
                                    showSort={true}
                                    onlyFilter={false}
                                    defaultDirection="asc"
                                    searchFieldType="date"
                                    dateFormat="RRRR-MM-DD"
                                    dateFromTo={true}
                                    filters={filters}
                                    sort={orders}
                                    breakLine={true}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={firstLoad}
                                    nullable={false}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} padding="none" align="center">
                                <TableHeaderContentCell
                                    title="pools:msisdn.deleted_time"
                                    fieldName="deletedTime"
                                    showSort={true}
                                    onlyFilter={false}
                                    defaultDirection="asc"
                                    searchFieldType="date"
                                    dateFormat="RRRR-MM-DD"
                                    dateFromTo={true}
                                    filters={filters}
                                    sort={orders}
                                    breakLine={true}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={firstLoad}
                                    nullable={false}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} align="center">
                                <TableHeaderContentCell
                                    textAlign="center"
                                    title="pools:msisdn.process_error"
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    fieldName="processed"
                                    showSort={true}
                                    searchFieldType="select"
                                    selectComponent="headerBooleanCheckBoxSelectList"
                                    filters={filters}
                                    sort={orders}
                                />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {msisdnPoolList &&
                            msisdnPoolList['hydra:member'].map((msisdnPoolFile) => {
                                let rowActiveColor = 'white';
                                if (activeRow === msisdnPoolFile.id) {
                                    rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
                                }
                                return (
                                    <TableRow
                                        classes={tableRowRoot}
                                        key={'key' + msisdnPoolFile.id}
                                        hover
                                        onClick={(): void => {
                                            setActiveRow(msisdnPoolFile.id);
                                        }}
                                        style={{ backgroundColor: rowActiveColor }}
                                    >
                                        <TableCell
                                            classes={tableControlStickyHeader}
                                            padding="none"
                                            align="left"
                                            style={{ backgroundColor: rowActiveColor }}
                                        >
                                            {msisdnPoolFile.processed && (
                                                <TemplateButton
                                                    icon={Report}
                                                    callback={viewReport}
                                                    callbackParam={{ ...msisdnPoolFile }}
                                                    tooltipTitle="pools:msisdn.process_report"
                                                />
                                            )}
                                            {!msisdnPoolFile.deleted && !msisdnPoolFile.runProcess && !msisdnPoolFile.processed && (
                                                <EditButton
                                                    tooltipTitle="pools:msisdn.edit_pool"
                                                    callback={editPools}
                                                    callbackParam={{ ...msisdnPoolFile }}
                                                />
                                            )}
                                            {!msisdnPoolFile.deleted && !msisdnPoolFile.runProcess && !msisdnPoolFile.processed && (
                                                <React.Fragment>
                                                    <TemplateButton
                                                        icon={PlayArrow}
                                                        callback={processPoolFile}
                                                        callbackParam={{ ...msisdnPoolFile }}
                                                        tooltipTitle="pools:msisdn.run_process"
                                                    />
                                                    <DeleteButton
                                                        tooltipTitle="pools:msisdn.delete_pool"
                                                        callback={deletePoolFile}
                                                        callbackParam={{ ...msisdnPoolFile }}
                                                    />
                                                </React.Fragment>
                                            )}
                                            {msisdnPoolFile.runProcess && (
                                                <TemplateButton
                                                    icon={HourglassEmpty}
                                                    callback={(): void => {}}
                                                    callbackParam={{}}
                                                    disabled={false}
                                                    tooltipTitle="pools:msisdn.process_file_in_progress"
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="center">
                                            {msisdnPoolFile.rangeFrom}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="center">
                                            {msisdnPoolFile.rangeTo}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="center">
                                            {getResellerName(msisdnPoolFile.platformResellerId)}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="center">
                                            {DateHelperTs.format(msisdnPoolFile.createdAt)}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="center">
                                            {msisdnPoolFile.processedDate && DateHelperTs.format(msisdnPoolFile.processedDate)}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="center">
                                            {msisdnPoolFile.deletedTime && DateHelperTs.format(msisdnPoolFile.deletedTime)}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="center">
                                            {msisdnPoolFile.processError}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={10}>
                                {msisdnPoolList && msisdnPoolList['hydra:view'] && (
                                    <Pager callback={paginationCallbackFunction} views={msisdnPoolList} />
                                )}
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </PaperedTable>
                <PlatformPoolFileChange
                    platformPoolFile={actionPool}
                    showMainLoader={showMainLoader}
                    reloadList={reloadList}
                    open={openEdit}
                    closeCallback={(): void => {
                        setOpenEdit(false);
                        setActionPool(null);
                    }}
                />
                <AlertDialog
                    open={openAlert}
                    titleDialog={alertTitle}
                    displayMessage={alertMessage}
                    closeCallback={(): void => {
                        setOpenAlert(false);
                        setAlertTitle('');
                        setAlertMessage('');
                        setTypeOfConfirm(-1);
                    }}
                    confirmCallback={confirmCallback}
                />
                <ViewReportDialog open={viewReportDialog} closeCallback={(): void => setViewReportDialog(false)} poolFile={viewReportPool} />
            </GridItem>
        </GridContainer>
    );
};

export default withStyles(oplAppStyle)(MsisdnPoolManager);
